// Constants for the app

export const REFERRAL_COOKIE = "awco-refId";
export const CAMPAIGN_ID = "awco-campaignId";
export const KEYWORD = "awco-keyword";
export const JOIN_ID = "awco-joinId";
// Set domain: ".afterword.com" if we want to share cookies
export const AFTERWORD_COOKIE_PARAMS = { path: "/" };
